import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "./Gallery.css";

const GalleryList = ({ user }) => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchGallery = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await axios.get(
        "https://ambatturindustrialestate.com/api/api/my-gallery/",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("Gallery API response:", response.data);

      if (response.data.groups) {
        const allMedia = response.data.groups.flatMap(
          (group) => group.media || []
        );
        setGalleryItems(allMedia);
      } else {
        setGalleryItems([]);
      }
    } catch (error) {
      console.error("Error fetching gallery:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load gallery items",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("access");
        await axios.delete(
          `https://ambatturindustrialestate.com/api/api/gallery-media/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Gallery item has been deleted.",
        });

        fetchGallery();
      } catch (error) {
        console.error("Error deleting gallery item:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete gallery item",
        });
      }
    }
  };

  if (loading) {
    return (
      <div className="gallery-container">
        <div className="gallery-loading">
          <div className="gallery-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-container">
      <div className="gallery-content">
        <div className="gallery-header gallery-fade-in">
          <h1 className="gallery-title">My Gallery</h1>
          <p className="gallery-subtitle">Manage your gallery media files</p>
          <div className="text-center">
            <Link to="/gallery/upload" className="gallery-upload-btn">
              <span>📷 Upload Media</span>
            </Link>
          </div>
        </div>

        {galleryItems.length === 0 ? (
          <div className="gallery-empty gallery-slide-up">
            <div className="gallery-empty-icon">📷</div>
            <h3 className="gallery-empty-title">No gallery items</h3>
            <p className="gallery-empty-text">
              Get started by uploading your first media file.
            </p>
            <Link to="/gallery/upload" className="gallery-upload-btn">
              Upload Media
            </Link>
          </div>
        ) : (
          <div className="gallery-grid">
            {galleryItems.map((item) => (
              <div key={item.id} className="gallery-item gallery-slide-up">
                <div className="gallery-media-container">
                  {item.media_type === "image" ? (
                    <img
                      src={item.media_file}
                      alt="Gallery media"
                      className="gallery-media"
                    />
                  ) : (
                    <video
                      src={item.media_file}
                      className="gallery-media"
                      controls
                    />
                  )}
                </div>
                <div className="gallery-item-content">
                  <span
                    className={`gallery-media-type ${
                      item.media_type === "image"
                        ? "gallery-media-type-image"
                        : "gallery-media-type-video"
                    }`}
                  >
                    {item.media_type}
                  </span>
                  <div className="gallery-actions">
                    <Link
                      to={`/gallery/edit/${item.id}`}
                      className="gallery-edit-btn"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="gallery-delete-btn"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GalleryList;
